// ./src/components/features/Forms/FormFieldsEditModal/BirthdateFieldOptionsEditor.tsx
import React from "react";
import { Stack, Text, Group, NumberInput } from "@mantine/core";
import { BirthdateFieldOptions } from "./fieldOptionsTypes";

export interface BirthdateFieldOptionsEditorProps {
  value: BirthdateFieldOptions;
  onChange: (options: BirthdateFieldOptions) => void;
}

export const BirthdateFieldOptionsEditor: React.FC<
  BirthdateFieldOptionsEditorProps
> = ({ value, onChange }) => {
  const handleChange = (
    field: keyof BirthdateFieldOptions,
    fieldValue: number | string
  ) => {
    onChange({
      ...value,
      [field]: fieldValue === "" ? undefined : fieldValue,
    });
  };

  return (
    <Stack gap="sm">
      <Text size="xs" c="dimmed">
        Set age restrictions based on the submitted birthdate. The backend will
        calculate the submitter's age at the time of submission.
      </Text>

      <Group grow>
        <NumberInput
          label="Minimum Age"
          placeholder="No minimum"
          description="Submitter must be at least this old"
          value={value.minAge ?? ""}
          onChange={(val) => handleChange("minAge", val)}
          min={0}
          max={150}
          size="sm"
        />

        <NumberInput
          label="Maximum Age"
          placeholder="No maximum"
          description="Submitter must be at most this old"
          value={value.maxAge ?? ""}
          onChange={(val) => handleChange("maxAge", val)}
          min={value.minAge ?? 0}
          max={150}
          size="sm"
        />
      </Group>

      {value.minAge !== undefined && value.maxAge !== undefined && (
        <Text size="xs" c="dimmed" ta="center">
          Allowed age range: {value.minAge} – {value.maxAge} years old
        </Text>
      )}

      {value.minAge !== undefined && value.maxAge === undefined && (
        <Text size="xs" c="dimmed" ta="center">
          Submitter must be at least {value.minAge} years old
        </Text>
      )}

      {value.minAge === undefined && value.maxAge !== undefined && (
        <Text size="xs" c="dimmed" ta="center">
          Submitter must be at most {value.maxAge} years old
        </Text>
      )}
    </Stack>
  );
};
